module.exports = __webpack_public_path__ + "static/media/foto2.8fb5480e.jpeg";